import { render } from "./ColliBloccatiTable.vue?vue&type=template&id=66e6155a&scoped=true"
import script from "./ColliBloccatiTable.vue?vue&type=script&lang=js"
export * from "./ColliBloccatiTable.vue?vue&type=script&lang=js"

import "./ColliBloccatiTable.vue?vue&type=style&index=0&id=66e6155a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e6155a"]])

export default __exports__